import React from 'react';
import { X } from 'lucide-react';
import { FamilyDocument } from '@/hooks/useDocuments';
import { DocumentItem } from './DocumentItem';
import { ModalDrawer } from '@/components/ui/modal-drawer';

interface CategoryDocumentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  category: 'medical' | 'identity' | 'school' | 'insurance' | 'other' | null;
  documents: FamilyDocument[];
  onDocumentClick: (documentId: string) => void;
}

const categoryLabels = {
  medical: 'Médical',
  identity: 'Identité',
  school: 'École',
  insurance: 'Assurance',
  other: 'Autre'
};

export const CategoryDocumentsModal: React.FC<CategoryDocumentsModalProps> = ({
  isOpen,
  onClose,
  category,
  documents,
  onDocumentClick
}) => {
  if (!category) return null;

  const categoryLabel = categoryLabels[category];

  return (
    <ModalDrawer
      open={isOpen}
      onOpenChange={onClose}
      title={`Documents ${categoryLabel}`}
      className="bg-white"
    >
      <div className="space-y-2 max-h-[60vh] overflow-y-auto p-4">
        {documents.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-muted-foreground">Aucun document dans cette catégorie</p>
          </div>
        ) : (
          documents.map((document) => (
              <DocumentItem
                key={document.id}
                document={document}
                onClick={() => onDocumentClick(document.id)}
              />
          ))
        )}
      </div>
    </ModalDrawer>
  );
};